import { type GameConfig, MagicSlot } from '@magic/slot';
import { demoConfig } from './demo';

const gameConfig: GameConfig = {
    cols: 5,
    rows: 3,
    symbols: ['H1', 'H2', 'H3', 'H4', 'L1', 'L2', 'L3', 'L4'],
    // wild and scatter — dealt by a round, never filled in at random
    specialSymbols: ['WI', 'SC'],
    minSpinTime: 0,
    reelStartDelay: 60,
    reelStopDelay: 200,
    anticipationSpinTime: 2000,
    minHeight: 1080,
    minWidth: 1080,
    sounds: [],
    // the page fills the popup panel between its title and its close button — the content
    // slot sits a little above the middle of that gap, hence the offset
    rules: {
        file: 'assets/static/rules.md',
        width: 880,
        height: 560,
        offset: { y: 27 },
        closeLabel: 'close',
        // the popup's close button is drawn over the spin button, so its own label has to go
        // while the page is up or the two read as one garbled word
        hideTexts: ['spin_button'],
    },
};

new MagicSlot(gameConfig, demoConfig);
